// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"17436612c84d60349b42","339":"e9106978625b2d2b5739"}[chunkId] + ".js";
};